import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6333815c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row q-col-gutter-lg" }
const _hoisted_2 = { id: "circularProgressContainer" }
const _hoisted_3 = {
  class: "col-xs-8",
  id: "pageTitleContainer"
}
const _hoisted_4 = {
  class: "text-h4 text-weight-bold",
  id: "pageTitle"
}
const _hoisted_5 = {
  key: 0,
  class: "q-py-xs",
  id: "pageDescription"
}
const _hoisted_6 = {
  class: "text-h5 text-weight-bold",
  id: "summaryTitle"
}
const _hoisted_7 = {
  class: "self-center full-width no-outline",
  id: "summaryFieldValue"
}
const _hoisted_8 = {
  class: "self-center full-width no-outline",
  id: "summaryFieldValue"
}
const _hoisted_9 = { class: "date-value" }
const _hoisted_10 = { class: "local-time" }
const _hoisted_11 = {
  class: "self-center full-width no-outline",
  id: "summaryFieldValue"
}
const _hoisted_12 = { class: "date-value" }
const _hoisted_13 = { class: "local-time" }
const _hoisted_14 = {
  class: "self-center full-width no-outline",
  id: "summaryFieldValue"
}
const _hoisted_15 = {
  class: "self-center full-width no-outline",
  id: "summaryFieldValue"
}
const _hoisted_16 = {
  key: 0,
  class: "text-h5 text-weight-bold",
  id: "summaryTitle"
}
const _hoisted_17 = {
  key: 1,
  class: "q-mb-md",
  id: "summaryContent"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 2,
  class: "text-h5 text-weight-bold",
  id: "summaryTitle"
}
const _hoisted_20 = {
  key: 3,
  class: "q-mb-md",
  id: "summaryContent"
}
const _hoisted_21 = {
  id: "groupTitle",
  class: "text-h6 text-weight-bold"
}
const _hoisted_22 = {
  key: 0,
  class: "text-list-label"
}
const _hoisted_23 = {
  class: "self-center full-width no-outline",
  id: "summaryFieldValue"
}
const _hoisted_24 = {
  class: "text-h5 text-weight-bold",
  id: "summaryTitle"
}
const _hoisted_25 = {
  class: "q-gutter-sm",
  id: "summaryContent"
}
const _hoisted_26 = {
  key: 0,
  class: "row"
}
const _hoisted_27 = {
  class: "col-xs-7 col-sm-5",
  id: "dataPolicyTitle"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "q-mx-md" }, "-", -1))
const _hoisted_29 = {
  class: "col-xs-3 col-sm-3",
  id: "dataPolicyActionSelected"
}
const _hoisted_30 = {
  class: "col-xs-7 col-sm-5",
  id: "inductionTitle"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "q-mx-md" }, "-", -1))
const _hoisted_32 = {
  class: "col-xs-3 col-sm-3",
  id: "inductionActionSelected"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircularProgress = _resolveComponent("CircularProgress")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_field = _resolveComponent("q-field")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CircularProgress)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.title)), 1),
        (_ctx.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.description)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_q_separator, {
      class: "q-my-md",
      id: "separator"
    }),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('portal_visitDetails')), 1),
    _createVNode(_component_q_card, {
      flat: "",
      bordered: "",
      id: "summaryContent"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            (_ctx.visitDetails && _ctx.visitDetails.locationName)
              ? (_openBlock(), _createBlock(_component_q_field, {
                  key: 0,
                  label: _ctx.$t('portal_visitLocation'),
                  "stack-label": "",
                  borderless: "",
                  id: "summaryField"
                }, {
                  control: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.visitDetails.locationName), 1)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.visitDetails && _ctx.visitDetails.entryDateLocal)
              ? (_openBlock(), _createBlock(_component_q_field, {
                  key: 1,
                  label: _ctx.$t('portal_entryDate'),
                  "stack-label": "",
                  borderless: "",
                  id: "summaryField"
                }, {
                  control: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.portal.getFormattedDate(_ctx.visitDetails.entryDateLocal)), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(' ('+ _ctx.$t('portal_localTime') + ')'), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.visitDetails && _ctx.visitDetails.exitDateLocal)
              ? (_openBlock(), _createBlock(_component_q_field, {
                  key: 2,
                  label: _ctx.$t('portal_exitDate'),
                  "stack-label": "",
                  borderless: "",
                  id: "summaryField"
                }, {
                  control: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.portal.getFormattedDate(_ctx.visitDetails.exitDateLocal)), 1),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(' ('+ _ctx.$t('portal_localTime') + ')'), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.visitDetails && _ctx.visitDetails.escortName)
              ? (_openBlock(), _createBlock(_component_q_field, {
                  key: 3,
                  label: _ctx.$t('portal_escort'),
                  "stack-label": "",
                  borderless: "",
                  id: "summaryField"
                }, {
                  control: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.visitDetails.escortName), 1)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.visitDetails && _ctx.visitDetails.notes)
              ? (_openBlock(), _createBlock(_component_q_field, {
                  key: 4,
                  label: _ctx.$t('portal_notes'),
                  "stack-label": "",
                  borderless: "",
                  id: "summaryField"
                }, {
                  control: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.visitDetails.notes), 1)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.portal.photoData != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('portal_photoCaptureTitle')), 1))
      : _createCommentVNode("", true),
    (_ctx.portal.photoData != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_q_card, {
            flat: "",
            bordered: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    id: "visitorPhoto",
                    src: _ctx.portal.photoData
                  }, null, 8, _hoisted_18)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.displayedFields.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('portal_visitorDetails')), 1))
      : _createCommentVNode("", true),
    (_ctx.displayedFields.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
            return (_openBlock(), _createBlock(_component_q_card, {
              flat: "",
              bordered: "",
              key: group,
              id: "groupContainer"
            }, {
              default: _withCtx(() => [
                group
                  ? (_openBlock(), _createBlock(_component_q_card_section, {
                      key: 0,
                      class: "group-heading"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t(group)), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_card_section, {
                  id: "fieldsContainer",
                  class: "group-body"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedFields, (field) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: field.cdfId
                      }, [
                        (field.groupName === group && field.typeId === 2 && (field.subTypeId === 7 || field.subTypeId === 5 || field.subTypeId === 4))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t(field.displayValue)), 1))
                          : _createCommentVNode("", true),
                        (field.groupName === group)
                          ? (_openBlock(), _createBlock(_component_q_field, {
                              key: 1,
                              label: _ctx.$t(field.displayValue),
                              "stack-label": "",
                              borderless: "",
                              id: "summaryField",
                              class: _normalizeClass(field.type.toLowerCase())
                            }, {
                              control: _withCtx(() => [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.portal.getFieldValue(field)), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "class"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('portal_inductionsSummary')), 1),
    _createVNode(_component_q_card, {
      flat: "",
      bordered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              (_ctx.portal.dataPolicyRequired===true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('portal_dataPolicyTitle')), 1),
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.portal.dataPolicyAgreed ? _ctx.$t('portal_btnAgree') : _ctx.$t('portal_btnDisagree')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inductions, (induction) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row",
                  key: induction.competencyId
                }, [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t(induction.inductionTitle)), 1),
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, _toDisplayString(induction.isCompleted === null ? _ctx.$t('portal_btnSkip') : induction.isCompleted ? _ctx.$t(induction.agreeButtonText) : _ctx.$t(induction.disagreeButtonText)), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}